import { mapState } from 'vuex';
import axios from 'axios';

import { redirectToApp, redirectToAppWithError } from '@/utils/appLoginHelper';
import { handleAPIError } from '@/utils/errorHelper';
import { smartFocus } from '@/utils/uiHelper';

import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';
import AppConsent from '@/components/sections/AppConsent/AppConsent.vue';
import GDPRConsent from '@/components/sections/GDPRConsent/GDPRConsent.vue';
import CompanyInfo from '@/components/sections/Login/CompanyInfo.vue';
import Loading from '@/components/widgets/Loading/Loading.vue';

// @vue/component
export default {
  name: 'Login',
  components: {
    PageHeader,
    Loading,
    AppConsent,
    'gdpr-consent': GDPRConsent,
    CompanyInfo,
  },
  data() {
    return {
      code: '',
      app: {},
      gdprSeen: false,
      companyInfo: undefined,

      state: 'normal',
      isLoading: true,
    };
  },
  created() {
    if (!this.$route.query.samlauth || !this.$route.query.iv) {
      this.$store.commit('showFatalError', {
        error: 'Login Failed',
        message: 'Invalid parameters',
        explanation: 'Missing required parameters. Please try again.',

        appError: 'server_error',
        appErrorExplanation: 'saml authentication failed, invalid parameters',
      });
      return;
    }
    this.postSAMLAuth();
  },
  computed: {
    ...mapState({
      afterLoginURL: (state) => {
        let baseURL = '';
        if (state.login.loginType === 'account') {
          baseURL = window.location.href.replace(/(\/launchpad\/saml\/auth)\/?/, '/');
        }
        return state.login.afterLoginURL || baseURL;
      },
      // eslint-disable-next-line
      title: (state) => state.site.siteInfo.displayOptions.showSiteNameOnLoginScreen ? state.site.siteInfo.name : 'Log in',
      loginType: (state) => state.login.loginType,
      loginState: (state) => state.login.loginState,
      appInfo: (state) => state.login.appInfo,
      inAppLogin: (state) => state.login.loginType === 'app',
    }),
  },
  methods: {
    postSAMLAuth() {
      const sa = this.$route.query.samlauth;
      const iv = this.$route.query.iv;
      const data = {
        samlauth: sa.replace(/ /g, '+'),
        iv: iv.replace(/ /g, '+'),
        SAMLAfterLoginURL: this.$route.query.SAMLAfterLoginURL,
      };

      let url = '/launchpad/v1/saml/auth.json';
      const appAuth = !!this.$route.query.appAuth;
      if (appAuth) {
        url += '?appAuth=true';
        data.redirect_uri = this.appInfo.redirect_uri;
        data.state = this.appInfo.state;
        data.client_id = this.appInfo.client_id;
        data.scope = this.appInfo.scope;
        data.install = this.appInfo.install;
        if (this.appInfo.nonce) data.nonce = this.appInfo.nonce;
      }

      if (this.gdprSeen) data.gdprSeen = true;

      axios.post(url, data).then((response) => {
        if (response.data.setupScreenRequired) {
          const { industryCategoryId, companySizeId } = response.data;

          this.companyInfo = {
            industryCategoryId: industryCategoryId || undefined,
            sizeId: companySizeId || undefined,
          };

          this.state = 'company-info';
          this.isLoading = false;

          return;
        }

        if (!response.data.gdprSeen) {
          this.state = 'gdpr-consent';
          this.gdprSeen = true;
          this.isLoading = false;
          return;
        }

        this.code = response.data.code;

        if (this.inAppLogin) {
          this.app = response.data.app;

          if (this.app.consentRequired === false) { // allow skipping screen for our own apps
            axios.post('/launchpad/v1/token/consent.json', { code: this.code }).then((res) => {
              redirectToApp(this.appInfo, res.data.code);
            }).catch(() => {
              redirectToAppWithError(this.appInfo, 'failed_to_consent', 'impossible to consent');
            });
          } else {
            this.state = 'app-consent';
          }

          this.isLoading = false;
          return;
        }

        this.$store.commit('setLoggedIn', {
          loggedIn: true,
          userId: response.data.userId,
        });

        if (window.opener &&
          this.$store.state.login.meta.hasLocalStorage &&
          sessionStorage.getItem('shouldCloseOpener') === 'true'
        ) {
          sessionStorage.setItem('shouldCloseOpener', 'false');
          window.close();
        }

        const location = response.data.redirectURL || this.afterLoginURL;
        window.location.href = location;
      }).catch((e) => {
        handleAPIError(
          this.$store, e,
          'Sorry, something went wrong and we could not log you in.',
        );
        this.isLoading = false;

        smartFocus();
      });
    },
    reload() {
      window.location.reload();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/SAMLAuth/SAMLAuth.js